
import { windowatch } from '../../../scripts/lib/windowatch';

const name = 'module-history';

// pixels per second
const tapeSpeed = 50;

export default class HistoryModule {

  constructor ($el) {
    this.$el = $el;

    this.ratio = $el.dataset.ratio;
    this.imageHeight = null;

    this.$tape = $el.querySelector(`.${name}__tape`);
    this.$image = this.$tape.querySelector(`.${name}__image`);

    // Clone image
    this.$imageDuplicate = this.$image.cloneNode(true);
    this.$tape.appendChild(this.$imageDuplicate);

    // Listen to resize events
    windowatch.addResizeListener(this.onResize.bind(this));
  }

  onResize () {
    // Measure height
    const height = this.$tape.getBoundingClientRect().height;
    if (this.imageHeight !== height) {
      this.imageHeight = height;
      const imageWidth = height / this.ratio;
      const animationDuration = imageWidth / tapeSpeed;

      return () => {
        // Apply width
        this.$image.style.width = `${parseInt(imageWidth)}px`;
        this.$imageDuplicate.style.width = `${parseInt(imageWidth)}px`;
        this.$tape.style.animationDuration = `${parseInt(animationDuration * 100) / 100}s`;
      };
    }
  }
}
